var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5723 21.2917C16.7137 21.2917 21.1659 14.5486 21.1659 8.70122C21.1659 8.50972 21.162 8.3191 21.1534 8.12927C22.0197 7.50258 22.7674 6.72664 23.3613 5.83784C22.5682 6.19034 21.7148 6.42759 20.8194 6.53456C21.7333 5.98674 22.4348 5.12008 22.7659 4.08703C21.897 4.60233 20.9464 4.96559 19.9552 5.16114C19.1475 4.30101 17.9976 3.76306 16.7243 3.76306C14.28 3.76306 12.2979 5.74476 12.2979 8.1875C12.2979 8.53479 12.3368 8.87248 12.4127 9.1965C8.73402 9.01144 5.47201 7.2506 3.2889 4.57315C2.8957 5.24845 2.68888 6.01595 2.68957 6.79727C2.68957 8.33251 3.47096 9.68778 4.65927 10.4807C3.95637 10.4592 3.2689 10.2694 2.65467 9.92722C2.65401 9.9458 2.65401 9.9639 2.65401 9.98375C2.65401 12.1268 4.17969 13.916 6.20499 14.3215C5.82461 14.425 5.4321 14.4774 5.03786 14.4772C4.75315 14.4772 4.47567 14.4492 4.206 14.3974C4.7695 16.1556 6.40349 17.4351 8.34078 17.4708C6.82584 18.6579 4.91749 19.365 2.84339 19.365C2.49056 19.3653 2.13802 19.3448 1.7876 19.3037C3.74651 20.5589 6.0723 21.2917 8.5723 21.2917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTweet);
export default __webpack_public_path__ + "static/media/tweet.471e1b0e46e8f6d96ba146be983c4d73.svg";
export { ForwardRef as ReactComponent };